import React from 'react';
import { useTranslation } from 'react-i18next';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { ChannelBox } from '../../../box';
import { ChannelBoxIcon } from '../../../box-icon';
import { usePressureControl } from '../../../hooks/use-pressure-control';
import { PowerState } from '../../../power';
import SensorDetailsWrapper from '../../../sensor-details-wrapper';
import PressureControl from '../controls';

type PressureDetailsControlsProps = {
  channel: IDeviceChannel;
};

export const PressureDetailsControls: React.FC<PressureDetailsControlsProps> = ({ channel }) => {
  const { t } = useTranslation('channel-details');
  const { time } = usePressureControl(channel);

  return (
    <SensorDetailsWrapper channel={channel}>
      <div className="details-controls grid-list-16">
        <div>
          <ChannelBox channel={channel} isListItem className="device-box--details">
            <div className="device-box__head">
              <ChannelBoxIcon channel={channel} />
              <PressureControl channel={channel} isListItem />
            </div>
          </ChannelBox>
          {time && <div className="details-controls__detection-time">{`${t('exalus.checked')} ${time}`}</div>}
        </div>
        <PowerState channel={channel} />
      </div>
    </SensorDetailsWrapper>
  );
};
